<template>
<v-container
  fluid
  grid-list-md
>
  <v-layout row wrap>
    <v-flex xs12 v-if="person">
      <v-toolbar flat
      :color="statusColor"
      extended class="pt-3" dense
      >
        <v-text-field
          class="ml-5"
          :label="`полное имя пользователя ${person.cardid || 'без карты'}`" placeholder="нет имени" style="max-width: 500px; font-size: 22px"
          v-model="person.fullname"
          :append-icon="person.fullname && person.fullname!=='' && person.fullname!==fullnameSaved ? 'save' : ''"
          :disabled="!isoperator"
          @click:append="renamePerson()"
          hide-details
        ></v-text-field>
        <span class="title weight-300 mx-3"><b>{{ rubles(person.account.balance) }}</b> р.</span>
        <b class="title weight-300 mx-3" v-if="person.position">
          {{person.school.name}}
        </b>
        <v-chip v-if="!person.fullname" color="error" text-color="white" class="py-1 px-3 ml-3">
          <v-avatar>
            <v-icon>warning</v-icon>
          </v-avatar>
          НЕ УКАЗАНО ИМЯ!
        </v-chip>
        <v-chip v-if="person.archived" color="warning darken-1" text-color="white" class="py-1 px-3 ml-3">
          <v-avatar>
            <v-icon>warning</v-icon>
          </v-avatar>
          АРХИВНЫЙ
        </v-chip>
        <v-chip v-else-if="!person.position" color="error" text-color="white" class="py-1 px-3 ml-3">
          <v-avatar>
            <v-icon>warning</v-icon>
          </v-avatar>
          НЕ ПРИВЯЗАН К ШКОЛЕ!
          <v-btn small dark @click="openChoosePositionDialog()" :disabled="!isoperator" class="ml-2">
            добавить в школу
            <v-icon right>add</v-icon>
          </v-btn>
        </v-chip>
        <v-chip v-if="!person.registered" color="info" text-color="white" class="py-1 px-3 ml-3">
          <v-avatar>
            <v-icon>info</v-icon>
          </v-avatar>
          НЕ ЗАРЕГИСТРИРОВАН
        </v-chip>

        <v-spacer></v-spacer>
        <v-icon left>credit_card</v-icon>
        <code class="subtitle-1 px-1 elevation-0" v-show="person.cardid">{{ person.cardid }}</code>

        <v-tabs slot="extension"
          fixed-tabs
          v-model="tab"
          class="py-0 darklight"
          :bbackground-color="statusColor"
          background-color="rgba(0,0,0,.04)"
          color="black"
          align-with-title dense
        >
          <v-tabs-slider color="secondary"></v-tabs-slider>
          <v-tab key="tab-1">
            Основное
          </v-tab>
          <v-tab key="tab-2">
            Трансферы
          </v-tab>
          <v-tab key="tab-3">
            Сообщения
          </v-tab>
          <v-tab key="tab-4">
            Чеки
          </v-tab>
          <v-tab key="tab-5">
            Ивенты
          </v-tab>
          <v-tab key="tab-6">
            ЛК
          </v-tab>
          <v-tab v-if="isadmin" key="tab-7">
            Действия
          </v-tab>
          <v-spacer></v-spacer>
        </v-tabs>
      </v-toolbar>

      <v-card flat>
        <v-card-text class="pt-0">
          <v-tabs-items v-model="tab" color="cyan" slider-color="yellow">

            <v-tab-item :key="'tab-1'">
              <v-card flat>
                <v-card-text>
                  <v-layout row wrap>

                    <v-flex xs2 d-flex>
                      <v-list>
                        <v-subheader class="px-0">Тариф: </v-subheader>
                        <i class="subtitle-1">{{ person.tariff.name }}</i>&nbsp;
                        <v-btn text small color="primary" @click="openChooseTariffDialog()" :disabled="!isoperator">
                          <v-icon small>edit</v-icon>
                        </v-btn>
                      </v-list>
                    </v-flex>

                    <v-flex xs2 d-flex v-if="isoperator">
                      <v-list>
                        <v-subheader class="pl-0">Пароль</v-subheader>
                        <span v-if="!person.registered">[ПОЛЬЗОВАТЕЛЬ НЕ ЗАРЕГИСТРИРОВАН]</span>
                        <v-btn small v-else-if="!credentials" @click="fetchCredentials()">
                          Показать пароль
                          <v-icon right>visibility_off</v-icon>
                        </v-btn>
                        <code v-else class="title">{{credentials.password}}</code>
                      </v-list>
                    </v-flex>

                    <v-flex xs3 d-flex>
                      <v-list>
                        <v-subheader class="px-0">Школа / Класс: </v-subheader>
                        <span class="" v-if="person.position">
                          {{person.school.name}}
                          &nbsp;/&nbsp;
                          {{person.position.name}}
                        </span>
                        <span v-else>
                          [НЕТ ШКОЛЫ]
                        </span>
                        <v-btn text small v-if="person.position" color="error" @click="deleteFromSchool()" :disabled="!isoperator">
                          <v-icon small>close</v-icon>
                        </v-btn>
                        <v-btn text small v-else color="primary" @click="openChoosePositionDialog()" :disabled="!isoperator">
                          <v-icon>add</v-icon>
                        </v-btn>
                      </v-list>
                    </v-flex>

                    <v-flex v-if="person.guests.length > 0" d-flex>
                      <v-list>
                        <v-subheader class="px-0">Гость в школе: </v-subheader>
                        <span>
                          <v-chip v-for="g of person.guests" small color="blue"><span style="color:white;">{{g.schoolid}}</span></v-chip>
                        </span>
                      </v-list>
                    </v-flex>

                    <v-flex xs12 class="my-2">
                      <v-divider></v-divider>
                    </v-flex>

                    <v-flex d-flex xs3>
                      <v-list class="pr-5">
                        <v-chip v-if="!person.cardid" color="error" text-color="white" class="py-1 px-3 ml-3">
                          <v-avatar>
                            <v-icon>warning</v-icon>
                          </v-avatar>
                          НЕТ АКТИВНОЙ КАРТЫ!
                        </v-chip>
                        <v-subheader class="px-0">Активная карта:
                          <v-spacer></v-spacer>
                          <code class="subtitle-1 px-1 elevation-0" v-show="person.cardid">{{ person.cardid }}</code>
                        </v-subheader>
                        <v-subheader class="px-0">Все карты:
                          <v-spacer></v-spacer>
                          <v-dialog
                            v-model="dialogTakeCard"
                            scrollable
                            persistent
                            width="500"
                            transition="dialog-transition"
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn text small v-on="on" color="primary"><v-icon>add</v-icon>новая карта</v-btn>
                            </template>
                            <v-card>
                              <v-card-title class="headline">
                                Добавить карту
                                <v-spacer></v-spacer>
                                <v-btn icon small @click="dialogTakeCard=false"><v-icon>close</v-icon></v-btn>
                              </v-card-title>
                              <v-card-text>
                                <v-text-field
                                  label="Карта" maxlength="9" minlength="9" counter
                                  v-model="icard" type="number"
                                ></v-text-field>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text @click="dialogTakeCard=false">Отмена</v-btn>
                                <v-btn
                                  text color="primary"
                                  @click="cardTake(icard)"
                                  :disabled="!icard || icard.length !== 9"
                                >Добавить</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-subheader>
                        <v-flex
                          xs12
                          v-for="card in person.cards"
                          :style="card.blocked ? 'color:grey' : ''"
                          :class="card.cardid === person.cardid ? 'active-card' : ''"
                        >
                          <v-btn small class="mx-1" icon v-if="card.cardid === person.cardid" disabled
                          style="background-color: #FBC02D !important">
                            <v-icon small color="yellow darken-2">star</v-icon>
                          </v-btn>
                          <v-btn small class="mx-1" icon v-else :disabled="card.blocked !== null"
                            @click="cardChooseActive(card.cardid)">
                            <v-icon small color="primary">star_border</v-icon>
                          </v-btn>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-if="card.bcardlinked" color="primary" v-bind="attrs" v-on="on" small class="mx-1">
                                credit_card
                              </v-icon>
                            </template>
                            <span>К этой карте привязана банковская карта</span>
                          </v-tooltip>
                          <v-btn small class="mx-1" icon @click="cardUnblock(card.cardid)"
                            v-if="card.blocked && card.cardid !== person.cardid"
                          >
                            <v-icon small color="error">lock</v-icon>
                          </v-btn>
                          <v-btn small class="mx-1" color="red" icon @click="cardUnblock(card.cardid)"
                            v-else-if="card.blocked && card.cardid === person.cardid"
                          >
                            <v-icon small color="black">lock</v-icon>
                          </v-btn>
                          <v-btn small class="mx-1" icon @click="cardBlock(card.cardid)"
                            v-else
                          >
                            <v-icon small color="primary">lock_open</v-icon>
                          </v-btn>
                          <span class="monospace">{{ card.cardid }}</span>&nbsp;&nbsp;
                          <span class="monospace grey--text">
                            {{ card.code }}
                          </span>
                          <v-btn text small icon color="red lighten-1"
                            @click="cardDisown(card.cardid)"
                            :disabled="!isoperator || (card.blocked !== null)"
                          >
                            <v-icon>close</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-list>
                    </v-flex>

                    <v-flex d-flex xs9>
                      <v-list>
                        <v-subheader class="px-0">
                          Адреса:
                          <v-btn icon small @click="dstlock = !dstlock" :disabled="!isoperator">
                            <v-icon small>{{dstlock ? 'lock' : 'lock_open'}}</v-icon>
                          </v-btn>
                          <v-dialog
                            v-model="dialogNewDst"
                            scrollable persistent modal
                            width="500" transition="dialog-transition"
                            v-if="person.registered && dstlock === false"
                            >
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" text small color="primary">
                                <v-icon>add</v-icon> новый адрес
                              </v-btn>
                            </template>
                            <v-card>
                              <v-card-title class="headline">
                                Добавление нового адреса
                                <v-spacer></v-spacer>
                                <v-btn icon small @click="dialogNewDst=false;newDstAddress=null"><v-icon>close</v-icon></v-btn>
                              </v-card-title>
                              <v-card-text>
                                <v-select
                                :items="['sms', 'email', 'telegram', 'vk', 'viber']"
                                v-model="newDstTransport"
                                label="Тип"
                                ></v-select>

                                <v-text-field
                                v-model="newDstAddress"
                                label="адрес"
                                ></v-text-field>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text @click="dialogNewDst=false;newDstAddress=null">ОТМЕНА</v-btn>
                                <v-btn
                                color="primary"
                                :disabled="newDstTransport === null || newDstAddress === null || newDstAddress.length < 6"
                                @click="addNewDst()"
                                >Добавить</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-subheader>

                        <v-flex xs12 v-if="!person.registered">
                          <span>[ПОЛЬЗОВАТЕЛЬ НЕ ЗАРЕГИСТРИРОВАН]</span>
                        </v-flex>
                        <v-flex xs12
                        v-for="dst in person.destinations"
                        v-else
                        class="text-xs-left align-center" style="height: 90px;"
                        >
                          <v-switch
                            style="float: left; margin-top: 0px"
                            hide-details v-model="dst.isnotfreezed"
                            color="primary" small @change="destinationToogleFreezed(dst)"
                            :disabled="dstlock"
                          >
                          </v-switch>
                          <v-chip dark :color="transportColor(dst.transport)" style="margin-top:0px">
                            <span style="width: 10ch">{{ dst.transport }}</span>
                            <span class="white--text">{{ dateFormat(dst.uts) }}</span>
                          </v-chip>
                          <v-flex style="display: inline-block; width: 36ch; text-align: center;" justify-center>{{ dst.address }}</v-flex>
                          <v-select style="display: inline-flex; margin-top: -10px; width: 340px;"
                            v-model="dst.subscriptions"
                            :items="subs(dst)"
                            item-text="title"
                            item-value="subid"
                            multiple
                            dense
                            :disabled="dstlock || dst.isnotfreezed === false"
                            @change="destinationUpdate(dst)"
                          >
                            <template v-slot:selection="{ item, index }">
                              <v-chip v-if="index < 3" small outlined color="success">
                                <span>{{ item.title }}</span>
                              </v-chip>
                              <small
                                v-if="index === 3"
                                class="grey--text text-caption"
                              >
                                (+{{ dst.subscriptions.length - 3 }} других)
                              </small>
                            </template>
                          </v-select>
                          <span class="like-a-btn ml-3">
                            <v-chip v-if="dst.params.ltp" small lable outlined color="red">
                              <span>{{ dst.params.limit }} р.</span>
                            </v-chip>
                          </span>
                          <v-menu offset-y bottom v-if="isadmin && dstlock === false">
                            <template v-slot:activator="{ on }">
                              <v-btn style="height: 36px" icon small v-on="on"><v-icon small>more_vert</v-icon></v-btn>
                            </template>
                            <v-list dense>
                              <v-list-item @click="destinationDelete(dst)">
                                <v-list-item-content>
                                  <v-list-item-title>Удалить</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-icon color="error">delete</v-icon>
                                </v-list-item-action>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-flex>
                      </v-list>
                    </v-flex>

                    <v-dialog
                      v-if="selectedTariff && selectedTariff.costs"
                      v-model="dialogChooseTariff"
                      scrollable
                      persistent
                      max-width="600"
                      transition="dialog-transition"
                    >
                    <v-card>
                      <v-card-title class="headline">
                        Выберите тариф
                        <v-spacer></v-spacer>
                        <v-btn icon small @click="dialogChooseTariff=false"><v-icon>close</v-icon></v-btn>
                      </v-card-title>
                      <v-card-text>
                        <v-select
                          :items="tariffs"
                          item-text="name"
                          v-model="selectedTariff"
                          label="Выберите тариф"
                          return-object
                        ></v-select>
                        id тарифа: <b>{{selectedTariff.tariffid}}</b><br>
                        Название тарифа: <b>{{selectedTariff.name}}</b><br>
                        <span>Стоимость списаний (в копейках):</span><br>
                        <span v-for="item in Object.keys(selectedTariff.costs)">
                          <i>[{{item}}]</i> -> <b>{{selectedTariff.costs[item]}}</b><br>
                        </span>
                        Активный?: <b>{{selectedTariff.active ? 'да' : 'нет'}}</b><br>
                        Доступен?: <b>{{selectedTariff.available ? 'да' : 'нет'}}</b>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn color="orange" outlined @click="closeChooseTariffDialog();">Отмена</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" outlined @click="updateTariff();">Применить</v-btn>
                      </v-card-actions>
                    </v-card>
                    </v-dialog>

                    <v-dialog
                      v-model="dialogChoosePosition"
                      scrollable persistent modal
                      width="500" transition="dialog-transition"
                    >
                      <v-card>
                        <v-card-title class="headline">
                          Выберите школу и класс
                          <v-spacer></v-spacer>
                          <v-btn icon small @click="dialogChoosePosition=false"><v-icon>close</v-icon></v-btn>
                        </v-card-title>
                        <v-card-text>
                          <v-autocomplete
                          flat class="mx-2"
                          label="школа"
                          :items="schools"
                          v-model="school"
                          :search-input.sync="searchSchools"
                          return-object item-text="name" clearable
                          ></v-autocomplete>

                          <v-autocomplete
                          flat class="mx-2"
                          label="класс"
                          :items="positions"
                          v-model="position"
                          :search-input.sync="searchPositions"
                          return-object item-text="name" clearable
                          ></v-autocomplete>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text @click="dialogChoosePosition=false">ОТМЕНА</v-btn>
                          <v-btn
                            color="primary"
                            :disabled="!position"
                            @click="updatePosition()"
                          >Назначить</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <v-flex xs12>
                      <v-list>
                        <v-divider class="my-3"></v-divider>

                        <v-subheader class="pl-0">Действия</v-subheader>
                          <v-btn
                            class="mr-4"
                            color="error" text-color="white"
                            @click="recalcPerson()"
                            :disabled="!isoperator"
                          >Пересчитать баланс</v-btn>
                          <v-dialog
                            v-model="dialogNewPayment"
                            scrollable persistent modal
                            width="640"
                            transition="dialog-transition"
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn class="mr-4" color="primary" v-on="on" :disabled="!isoperator">Зачислить платёж</v-btn>
                            </template>
                            <v-card>
                              <v-card-title class="subtitle-1">
                                Новый платёж для&nbsp;<b>{{person.fullname}}</b>, карта {{person.cardid}}
                                <v-spacer></v-spacer>
                                <v-btn icon small @click="dialogNewPaymentClose()"><v-icon>close</v-icon></v-btn>
                              </v-card-title>
                              <v-card-text>
                                <v-text-field
                                v-model="paymentAmount"
                                label="Сумма в копейках"
                                ></v-text-field>
                                <v-text-field
                                v-model="paymentTicket"
                                label="Тикет"
                                append-icon="casino"
                                @click:append="generateUuid()"
                                ></v-text-field>
                                <v-select
                                  :items="profile.canaddpaymentsas"
                                  v-model="paymentOrgid"
                                  label="Организация"
                                ></v-select>
                                <v-checkbox label="Фискализировать?" v-model="paymentNeedFiscal"></v-checkbox>
                              </v-card-text>
                              <v-card-actions>
                                <v-btn
                                  color="primary"
                                  :disabled="!paymentTicket || !paymentOrgid || paymentAmount < -1000000 || paymentAmount > 1000000 || paymentAmount === 0"
                                  @click="addPayment()"
                                >
                                  Зачислить/Списать {{rubles(paymentAmount || 0)}} рублей
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn text
                                  @click="dialogNewPaymentClose()"
                                >Отмена</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>

                          <v-btn
                            class="mr-4"
                            color="warning" text-color="white"
                            @click="unarchive()"
                            :disabled="!isoperator || !person.archived"
                          >Разархивировать</v-btn>

                          <v-btn
                            class="mr-4"
                            color="error" text-color="white"
                            @click="deletePerson()"
                            :disabled="!isadmin || person.cards.length > 0"
                          >Удалить</v-btn>

                          <v-btn
                            class="mr-4"
                            color="warning" text-color="white"
                            @click="unregister()"
                            :disabled="!isadmin || !person.registered"
                          >Сбросить регистрацию</v-btn>

                      </v-list>
                    </v-flex>

                  </v-layout>

                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item :key="'tab-2'">
              <v-card flat>
                <v-card-text class="px-0">
                  <v-flex xs12 class="pa-0">
                    <v-toolbar dense flat class="pa-0 mx-0 mb-4">

                      <v-menu offset-y bottom>
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            class="mx-3" label="старт"
                            v-model="tstart" v-on="on" hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker locale="ru" first-day-of-week="1" v-model="tstart" :landscape="true" :reactive="true"
                        @change="fetchTransfers()"
                        ></v-date-picker>
                      </v-menu>

                      <v-menu offset-y bottom>
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            class="mx-3" label="финиш"
                            v-model="tend" v-on="on" hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker locale="ru" first-day-of-week="1" v-model="tend" :landscape="true" :reactive="true"
                        @change="fetchTransfers()"
                        ></v-date-picker>
                      </v-menu>

                      <v-btn color="primary" class="ml-0" text @click="tstart=null; tend=null; fetchTransfers()">
                        За всё время
                      </v-btn>

                      <v-spacer></v-spacer>
                      <v-text-field
                        label="поиск по фильтру"
                        v-model="searchTransfers"
                        append-icon="search"
                        outlined clearable hide-details flat
                      ></v-text-field>

                      <v-spacer></v-spacer>

                      <v-flex xs4>
                        <span v-show="results.startBalance !== undefined">
                          баланс: <b>{{rubles(results.startBalance)}}</b> -> <b>{{rubles(results.endBalance)}}</b>
                          </span>
                        <br />
                        <span>платежи: <b>{{rubles(results.sumPayments)}} &nbsp;</b></span>
                        <span>уведомления: <b>{{rubles(results.sumNoty)}} &nbsp;</b></span>
                        <span>другие: <b>{{rubles(results.sumOther)}} &nbsp;</b></span>
                      </v-flex>
                      <v-btn icon color="secondary" @click="fetchTransfers()"><v-icon>replay</v-icon></v-btn>
                    </v-toolbar>
                  </v-flex>
                  <ListTransfers
                    :transfers="transfers"
                    :sort-by="null"
                    :search="searchTransfers"
                    @search="x => searchTransfers=x"
                    :as-admin="isadmin"
                  ></ListTransfers>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item :key="'tab-3'">
              <v-card flat>
                <v-card-text class="px-0">
                  <v-flex xs12 class="pa-0">
                    <v-toolbar dense flat class="pa-0 mx-0 mb-4">

                      <v-menu offset-y bottom>
                        <template v-slot:activator="{ on }">
                          <v-text-field class="mx-3" label="старт"
                          v-model="mstart" v-on="on" hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker locale="ru" first-day-of-week="1" v-model="mstart" :landscape="true" :reactive="true"
                        @change="fetchMessages()"
                        ></v-date-picker>
                      </v-menu>

                      <v-menu offset-y bottom>
                        <template v-slot:activator="{ on }">
                          <v-text-field class="mx-3" label="финиш"
                          v-model="mend" v-on="on" hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker locale="ru" first-day-of-week="1" v-model="mend" :landscape="true" :reactive="true"
                        @change="fetchMessages()"
                        ></v-date-picker>
                      </v-menu>

                      <v-btn color="primary" class="ml-0"  text @click="mstart=null; mend=null; fetchMessages()">За всё время</v-btn>
                      <v-spacer></v-spacer>
                      <v-text-field
                      label="поиск по фильтру"
                      v-model="searchMessages"
                      append-icon="search"
                      outlined clearable hide-details flat
                      ></v-text-field>

                      <v-spacer></v-spacer>

                      <v-flex xs4>
                      </v-flex>
                      <v-btn icon @click="fetchMessages()"><v-icon>replay</v-icon></v-btn>
                    </v-toolbar>
                  </v-flex>
                  <ListMessages
                    :messages="messages"
                    :sort-by="null"
                    :search="searchMessages"
                    @search="x => searchMessages=x"
                    @totransfers="x => { searchTransfers=x; tab=1 }"
                  ></ListMessages>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item :key="'tab-4'">
              <v-card flat>
                <v-card-text class="px-0">
                  <v-flex xs12 class="pa-0">
                    <v-toolbar dense flat class="pa-0 mx-0 mb-4">

                      <v-menu offset-y bottom>
                        <template v-slot:activator="{ on }">
                          <v-text-field class="mx-3" label="старт"
                          v-model="cstart" v-on="on" hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker locale="ru" first-day-of-week="1" v-model="cstart" :landscape="true" :reactive="true"
                        @change="fetchChecks()"
                        ></v-date-picker>
                      </v-menu>

                      <v-menu offset-y bottom>
                        <template v-slot:activator="{ on }">
                          <v-text-field class="mx-3" label="финиш"
                          v-model="cend" v-on="on" hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker locale="ru" first-day-of-week="1" v-model="cend" :landscape="true" :reactive="true"
                        @change="fetchChecks()"
                        ></v-date-picker>
                      </v-menu>

                      <v-btn color="primary" class="ml-0"  text @click="cstart=null; cend=null; fetchChecks()">За всё время</v-btn>
                      <v-spacer></v-spacer>
                      <v-text-field
                      label="поиск по фильтру"
                      v-model="searchChecks"
                      append-icon="search"
                      outlined clearable hide-details flat
                      ></v-text-field>

                      <v-spacer></v-spacer>

                      <v-flex xs4>
                      </v-flex>
                      <v-btn icon @click="fetchChecks()"><v-icon>replay</v-icon></v-btn>
                    </v-toolbar>
                  </v-flex>
                  <ListChecks
                    :checks="checks"
                    :sort-by="null"
                    :search="searchChecks"
                    @search="x => searchChecks=x"
                  ></ListChecks>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item :key="'tab-5'">
              <v-card flat>
                <v-card-text class="px-0">
                  <v-flex xs12 class="pa-0">
                    <v-toolbar dense flat class="pa-0 mx-0 mb-4">

                      <v-menu offset-y bottom>
                        <template v-slot:activator="{ on }">
                          <v-text-field class="mx-3" label="старт"
                          v-model="estart" v-on="on" hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker locale="ru" first-day-of-week="1" v-model="estart" :landscape="true" :reactive="true"
                        @change="fetchEvents()"
                        ></v-date-picker>
                      </v-menu>

                      <v-menu offset-y bottom>
                        <template v-slot:activator="{ on }">
                          <v-text-field class="mx-3" label="финиш"
                          v-model="eend" v-on="on" hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker locale="ru" first-day-of-week="1" v-model="eend" :landscape="true" :reactive="true"
                        @change="fetchEvents()"
                        ></v-date-picker>
                      </v-menu>

                      <v-btn color="primary" class="ml-0"  text @click="estart=null; eend=null; fetchEvents()">За всё время</v-btn>
                      <v-spacer></v-spacer>
                      <v-text-field
                      label="поиск по фильтру"
                      v-model="searchEvents"
                      append-icon="search"
                      outlined clearable hide-details flat
                      ></v-text-field>

                      <v-spacer></v-spacer>

                      <v-flex xs4>
                      </v-flex>
                      <v-btn icon @click="fetchEvents()"><v-icon>replay</v-icon></v-btn>
                    </v-toolbar>
                  </v-flex>
                  <ListEvents
                    :events="events"
                    :sort-by="null"
                    :search="searchEvents"
                    @search="x => searchEvents=x"
                  ></ListEvents>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item :key="'tab-6'">
              <v-card flat>
                <v-card-text>
                  <v-list>
                    <v-subheader class="pl-0">Уведомления в ЛК
                      <v-dialog
                        v-model="dialogNewSN"
                        scrollable persistent modal
                        width="800" transition="dialog-transition"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn text color="primary" v-on="on">
                            <v-icon small>add</v-icon>
                          </v-btn>
                        </template>

                        <v-card>
                          <v-card-title class="headline">
                            Введите текст сообщения
                            <v-spacer></v-spacer>
                            <v-btn icon small @click="dialogNewSN=false"><v-icon>close</v-icon></v-btn>
                          </v-card-title>
                          <v-card-text>
                            <v-textarea
                              flat class="mx-2"
                              label="текст (HTML-разметка поддерживается)"
                              v-model="sncontent"
                              clearable
                            ></v-textarea>

                          </v-card-text>
                          <v-card-actions>
                            <v-menu offset-y top>
                              <template v-slot:activator="{ on }">
                                <v-btn text v-on="on">Превью</v-btn>
                              </template>
                              <v-card>
                                <v-card-text>
                                  <p v-html="(sncontent || '').split('\n').join('<br />')">
                                  </p>
                                </v-card-text>
                              </v-card>
                            </v-menu>

                            <v-spacer></v-spacer>
                            <v-btn text @click="dialogNewSN=false">ОТМЕНА</v-btn>
                            <v-btn
                              color="primary"
                              :disabled="!sncontent"
                              @click="sendSN()"
                            >Отправить</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                    </v-subheader>
                    <ListSitenotifications
                      :sitenotifications="sitenotifications"
                      @deleteSN="x => deleteSN(x)"
                    ></ListSitenotifications>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item :key="'tab-7'">
              <v-card flat>
                <v-card-text>
                  <v-flex xs12 lg3 md3 class="pa-0">
                    <v-toolbar dense flat class="pa-0 mx-0 mb-4">
                      <v-text-field
                        label="поиск по фильтру"
                        v-model="searchActions"
                        append-icon="search"
                        outlined clearable hide-details flat
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <v-btn icon color="secondary" @click="fetchUserActions()"><v-icon>replay</v-icon></v-btn>
                    </v-toolbar>
                  </v-flex>
                  <ListUserActions
                  :userActions="userActions"
                  :sort-by="null"
                  :search="searchActions"
                  @search="x => searchActions=x"
                  :as-admin="isadmin"
                  ></ListUserActions>
                </v-card-text>
              </v-card>
            </v-tab-item>

          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>

</template>

<script>
import ListTransfers from '@/components/ListTransfers.vue'
import ListMessages from '@/components/ListMessages.vue'
import ListChecks from '@/components/ListChecks.vue'
import ListEvents from '@/components/ListEvents.vue'
import ListSitenotifications from '@/components/ListSitenotifications.vue'
import ListUserActions from '@/components/ListUserActions.vue'
import moment from 'moment'
const uuid = require('uuid/v4')
export default {
  name: 'Person',
  props: [ 'personid' ],
  components: { ListTransfers, ListMessages, ListEvents, ListSitenotifications, ListChecks, ListUserActions },
  data: () => ({
    person: null,
    fullnameSaved: null,
    menuFullnameEdit: false,
    ifullname: null,
    tab: 0,
    cardsHeaders: [
      { value: 'cardid', name: 'id' },
      { value: 'code', name: 'внутренний код' },
      { value: 'cts', name: 'дата' },
      { value: 'blocked', name: 'блок' },
    ],
    dialogTakeCard: false,
    dialogNewSN: false,
    icard: null,

    dialogChooseTariff: false,
    tariffs: [],
    selectedTariff: {},

    transfers: [],
    searchTransfers: '',
    tstart: moment().startOf('year').format('YYYY-MM-DD'),
    tend: moment().endOf('year').format('YYYY-MM-DD'),

    messages: [],
    searchMessages: '',
    mstart: moment().startOf('year').format('YYYY-MM-DD'),
    mend: moment().endOf('year').format('YYYY-MM-DD'),

    checks: [],
    searchChecks: '',
    cstart: moment().startOf('year').format('YYYY-MM-DD'),
    cend: moment().endOf('year').format('YYYY-MM-DD'),

    events: [],
    searchEvents: '',
    estart: moment().startOf('year').format('YYYY-MM-DD'),
    eend: moment().endOf('year').format('YYYY-MM-DD'),

    sitenotifications: [],
    sncontent: null,

    dialogNewPayment: false,
    paymentAmount: 0,
    paymentTicket: null,
    paymentOrgid: null,
    paymentNeedFiscal: false,

    dialogUnarchive: false,

    dialogChoosePosition: false,
    school: null,
    position: null,
    schools: [],
    positions: [],
    searchSchools: null,
    searchPositions: null,
    searchActions: null,

    dstlock: true,
    dialogNewDst: false,
    newDstTransport: null,
    newDstAddress: null,

    credentials: null,

    userActions: []

  }),
  computed: {
    query () {
      return this.$route.query
    },
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    isadmin () {
      return this.scopes.includes('admin')
    },
    isoperator () {
      return this.scopes.includes('operator')
    },
    statusColor () {
      if (!this.person) return
      if (this.person.archived) return 'blue-grey lighten-2'
      if (!this.person.positionid) return 'rgba(250, 50, 50, .15)'
      if (!this.person.registered) return ''
      return 'green lighten-4'
    },
    results () {
      return this.transfers.reduce((r, x) => {
        if (!r.minid || r.minid > parseInt(x.transferid)) {
          r.minid = parseInt(x.transferid)
          r.startBalance = parseInt(x.result) - parseInt(x.amount)
        }
        if (!r.maxid || r.maxid < parseInt(x.transferid)) {
          r.maxid = parseInt(x.transferid)
          r.endBalance = parseInt(x.result)
        }
        if (x.purposeid === 'payment') {
          r.sumPayments += parseInt(x.amount)
        } else if (x.purposeid === 'noty') {
          r.sumNoty += parseInt(x.amount)
        } else {
          r.sumOther += parseInt(x.amount)
        }
        return r
      }, {
        sumPayments: 0,
        sumNoty: 0,
        sumOther: 0,
      })
    }
  },
  methods: {
    async fetch () {
      this.credentials = null
      this.fetchPerson()
    },
    async fetchPerson () {
      try {
        const { meta, person } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-person',
          pl: { personid: this.personid }
        })
        person.destinations = person.destinations.map(x => {
          x.isnotfreezed = x.freezed === null
          return x
        })
        this.person = person
        this.fullnameSaved = person.fullname
        this.fetchTariffs()
        this.fetchTransfers()
        this.fetchMessages()
        this.fetchChecks()
        this.fetchEvents()
        this.fetchSitenotifications()
        if (this.isadmin) {
          this.fetchUserActions()
        }
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchTransfers () {
      try {
        const { meta, transfers } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-transfers',
          pl: {
            personid: this.personid,
            start: this.tstart,
            end: this.tend,
            orderby: 'transferid',
            order: 'desc',
          }
        })
        this.transfers = transfers
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchMessages () {
      try {
        const { meta, messages } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-messages',
          pl: {
            personid: this.personid,
            start: this.mstart,
            end: this.mend,
            orderby: 'cts',
            order: 'desc'
          }
        })
        this.messages = messages
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchChecks () {
      try {
        const { meta, checks } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-checks',
          pl: {
            personid: this.personid,
            start: this.cstart,
            end: this.cend,
            orderby: 'cts',
            order: 'desc'
          }
        })
        this.checks = checks
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchEvents () {
      try {
        const { meta, events } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-events',
          pl: {
            personid: this.personid,
            start: this.estart,
            end: this.eend,
            orderby: 'originalts',
            order: 'desc'
          }
        })
        this.events = events
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchSitenotifications () {
      try {
        const { meta, sitenotifications } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-sitenotifications',
          pl: {
            personid: this.personid
          }
        })
        this.sitenotifications = sitenotifications
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchUserActions () {
      try {
        const { meta, userActions } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-user-actions',
          pl: {
            personid: this.personid
          }
        })
        this.userActions = userActions
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchSchools () {
      if (this.schools.length > 0) return this.schools
      try {
        const { meta, schools } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-schools'
        })
        this.schools = schools
        if (this.person.school) {
          this.school = this.person.school
          this.position = this.person.position
        }
        return schools
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetchPositions()
      }
    },
    async fetchPositions () {
      if (!this.school) return []
      try {
        const { meta, positions } = await this.$store.dispatch('sioRequest', {
          topic: 'filter-positions',
          pl: {
            schoolid: this.school.schoolid
          }
        })
        this.positions = positions
        return positions
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchCredentials () {
      try {
        const { meta, credentials } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-credentials',
          pl: { personid: this.person.personid }
        })
        this.credentials = credentials
        return credentials
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchTariffs () {
      try {
        const { tariffs } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-tariffs',
          pl: {}
        })
        this.tariffs = tariffs
        this.selectedTariff = this.tariffs.find(x => x.tariffid === this.person.tariffid)
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    closeChooseTariffDialog () {
      this.selectedTariff = {}
      this.dialogChooseTariff = false
    },
    async updateTariff () {
      await this.$store.dispatch('sioRequest', {
        topic: 'update-tariff',
        pl: {
          personid: this.person.personid,
          tariffid: this.selectedTariff.tariffid
        }
      })
      this.closeChooseTariffDialog()
      await this.fetch()
    },
    async sendSN () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'add-sitenotification',
          pl: { personid: this.person.personid, content: this.sncontent.split('\n').join('<br />') }
        })
        this.dialogNewSN = false
        this.fetchSitenotifications()
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async deleteSN (sn) {
      try {
        const { sitenotificationid } = sn
        await this.$store.dispatch('confirm', `Удалить уведомление #${sitenotificationid}?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'delete-sitenotification',
          pl: { sitenotificationid }
        })
        this.fetchSitenotifications()
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    ruService (service) {
      if (service === 'payment') return 'Платежи'
      if (service === 'lowbalance') return 'Баланс'
      if (service === 'pass') return 'Проходы'
      if (service === 'purchase') return 'Покупки'
      if (service === 'news') return 'Новости'
      return service
    },
    rubles (kops) {
      return (parseFloat(kops) / 100).toFixed(2)
    },
    dateFormat (date) {
      return moment(date).format('YY-MM-DD HH:mm')
    },
    transportColor (t) {
      if (t === 'sms') return 'orange lighten-2'
      if (t === 'email') return 'red lighten-2'
      if (t === 'telegram') return 'blue lighten-2'
      if (t === 'vk') return 'blue accent-2'
      if (t === 'viber') return 'deep-purple lighten-1'
      return 'green lighten-2'
    },
    async openChoosePositionDialog () {
      if (this.person.archived) {
        this.$store.dispatch('snack', new Error('Нельзя назначить школу архивному пользователю'))
      } else {
        this.dialogChoosePosition = true
        this.fetchSchools()
      }
    },
    async openChooseTariffDialog () {
      await this.fetchTariffs()
      this.dialogChooseTariff = true
    },
    async deleteFromSchool () {
      try {
        await this.$store.dispatch('confirm', `Удалить пользователя ${this.person.fullname} из школы?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'delete-from-school',
          pl: { personid: this.person.personid }
        })
        this.$store.dispatch('snack', meta)
        this.fetchPerson()
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async updatePosition () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'update-position',
          pl: { personid: this.person.personid, positionid: this.position.positionid }
        })
        this.$store.dispatch('snack', meta)
        this.fetchPerson()
        this.dialogChoosePosition = false
        this.school = null
        this.position = null
        this.positions = []
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async unarchive () {
      try {
        await this.$store.dispatch('confirm', `Снять статус "архивный" с ${this.person.fullname}, карта ${this.person.cardid} ?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'unarchive',
          pl: { personid: this.person.personid }
        })
        this.$store.dispatch('snack', meta)
        this.fetchPerson()
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async unregister () {
      try {
        await this.$store.dispatch('confirm', `Сбросить регистрацию ЛК ${this.person.fullname} ?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'unregister',
          pl: { personid: this.person.personid }
        })
        this.$store.dispatch('snack', meta)
        this.fetchPerson()
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async renamePerson () {
      try {
        await this.$store.dispatch('confirm', `Сменить имя с ${this.fullnameSaved} на ${this.person.fullname} ?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'rename-person',
          pl: { personid: this.person.personid, fullname: this.person.fullname }
        })
        this.$store.dispatch('snack', meta)
        this.fetchPerson()
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async cardTake (cardid) {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'card-take',
          pl: { personid: this.person.personid, cardid }
        })
        this.$store.dispatch('snack', meta)
        this.fetchPerson()
        this.dialogTakeCard = false
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async cardDisown (cardid) {
      try {
        await this.$store.dispatch('confirm', `Отвязать карту ${cardid} ?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'card-disown',
          pl: { personid: this.person.personid, cardid }
        })
        this.$store.dispatch('snack', meta)
        this.fetchPerson()
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async cardBlock (cardid) {
      try {
        await this.$store.dispatch('confirm', `Заблокировать карту ${cardid} ?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'card-block',
          pl: { personid: this.person.personid, cardid }
        })
        this.$store.dispatch('snack', meta)
        this.fetchPerson()
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async cardUnblock (cardid) {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'card-unblock',
          pl: { personid: this.person.personid, cardid }
        })
        this.$store.dispatch('snack', meta)
        this.fetchPerson()
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async cardChooseActive (cardid) {
      try {
        await this.$store.dispatch('confirm', `Выбрать активной карту ${cardid} ?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'card-choose-active',
          pl: { personid: this.person.personid, cardid }
        })
        this.$store.dispatch('snack', meta)
        this.fetchPerson()
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async destinationToogleFreezed (destination) {
      try {
        if (destination.freezed) {
          await this.$store.dispatch('confirm', `Активировать адрес ${destination.address} ?`)
        } else {
          await this.$store.dispatch('confirm', `Отключить адрес ${destination.address} ?`)
        }
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'destination-freeze-toggle',
          pl: { destinationid: destination.destinationid }
        })
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetchPerson()
      }
    },
    async destinationUpdate (destination) {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'destination-update',
          pl: destination
        })
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetchPerson()
      }
    },
    async destinationDelete (destination) {
      try {
        await this.$store.dispatch('confirm', `УДАЛИТЬ адрес ${destination.address} ?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'destination-delete',
          pl: destination
        })
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetchPerson()
      }
    },
    generateUuid () {
      this.paymentTicket = uuid()
    },
    dialogNewPaymentClose () {
      this.dialogNewPayment = false
      this.paymentAmount = 0
      this.paymentTicket = null
    },
    async addPayment () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'add-payment',
          pl: {
            cardid: this.person.cardid,
            ticket: this.paymentTicket,
            amount: this.paymentAmount,
            orgid: this.paymentOrgid,
            needfiscal: this.paymentNeedFiscal
          }
        })
        this.dialogNewPaymentClose()
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetchPerson()
      }
    },
    async recalcPerson () {
      try {
        const { personid } = this.person
        const operator = this.profile.email
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'recalc-person',
          pl: { personid, operator }
        })
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetchPerson()
      }
    },
    async addNewDst () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'add-dst',
          pl: {
            personid: this.person.personid,
            address: this.newDstAddress,
            transport: this.newDstTransport,
          }
        })
        this.dialogNewDst = false
        this.newDstAddress = null
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetchPerson()
      }
    },
    async deletePerson () {
      try {
        await this.$store.dispatch('confirm', `Удалить пользователя ${this.person.fullname} @ ${this.person.personid} ?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'delete-person',
          pl: {
            personid: this.person.personid,
          }
        })
        this.$router.push({ name: 'persons' })
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetchPerson()
      }
    },
    subs (item) {
      if (item.transport === 'sms') {
        return [
          { subid: 'payment', title: 'Платежи' },
          { subid: 'lowbalance', title: 'Баланс' },
          { subid: 'pass', title: 'Проходы' }
        ]
      }
      return [
        { subid: 'payment', title: 'Пополнение шк.пит.' },
        { subid: 'lowbalance', title: 'Баланс' },
        { subid: 'pass', title: 'Проходы' },
        { subid: 'purchase', title: 'Покупки' },
        { subid: 'news', title: 'Новости' },
        // { subid: 'ride', title: 'Проезд в транспорте' },
        // { subid: 'ridepayment', title: 'Пополнение транспорта' }
      ]
    }
  },
  watch: {
    profile (val) {
      if (val) this.fetch()
    },
    personid (val) {
      if (val) this.fetch()
    },
    query (val) {
      console.log(val)
      if (val.tab) this.tab = val.tab
    },
    searchSchools (val) {
      if (val) {
        this.fetchPositions()
      } else {
        this.positions = []
        this.position = null
      }
    },
    dialogTakeCard () {
      this.icard = null
    },
    dialogNewPayment (val) {
      if (val) this.generateUuid()
    }
  },
  mounted () {
    if (this.profile) this.fetch()
  },
}
</script>

<style lang="css">
 .active-card {
   background-color: rgba(255, 235, 59, 0.3);
 }
</style>
